import { rem } from 'polished'

const DURATION_CARD_WIDTH = rem(132)

export const DURATION_CAROUSEL_PROPS = {
  pageSize: 'auto' as const,
  snap: 'start' as const,
  width: DURATION_CARD_WIDTH,
  tabletWidth: DURATION_CARD_WIDTH,
  desktopWidth: DURATION_CARD_WIDTH,
}
